import React from "react"
export const LocationContext = React.createContext()

export const useLocation = () => {
  const location = React.useContext(LocationContext)
  location.buildHref = `https://www.klipfolio.com${location.pathname}`
  return location
}
